export const psychiatryConst = {
  path: "/single-programs/psychiatry",
  title: "ФАКУЛЬТЕТ МЕДИЦИНЫ — ПСИХИАТРИЯ",
  contentJSX: (
    <>
      <p>
        <strong>Диплом:</strong> магистра
      </p>
      <p>
        <strong>Форма обучения:</strong> очная или дистанционная
      </p>
      <p>
        <strong>Форма связи:</strong> получить консультацию приемной комиссии
      </p>
      <h2>Психиатрия — помощь там, где она особенно необходима</h2>
      <p>
        Психиатрия — это одна из самых значимых и сложных областей медицины, направленная на диагностику, лечение и профилактику психических
        расстройств. Психическое здоровье — неотъемлемая часть общего благополучия человека, и современные психиатры играют ключевую роль в
        поддержании этого баланса.
      </p>
      <p>
        Программа сочетает фундаментальную медицинскую подготовку с глубоким изучением клинической психиатрии, психофармакологии и
        психотерапии.
      </p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Общая и клиническая психиатрия</li>
        <li>Психофармакология и методы медикаментозного лечения</li>
        <li>Психотерапевтические подходы (когнитивно-поведенческая, психодинамическая и др.)</li>
        <li>Судебная психиатрия</li>
        <li>Психиатрия в экстренных состояниях</li>
        <li>Психосоматические расстройства</li>
        <li>Этические и правовые аспекты психиатрии</li>
        <li>Психиатрическая помощь детям и подросткам</li>
      </ul>
      <p>Программа включает практику в клиниках, специализированных отделениях и участие в междисциплинарных консилиумах.</p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Врач-психиатр в государственных и частных учреждениях</li>
        <li>Психотерапевт (при наличии дополнительной подготовки и лицензии)</li>
        <li>Судебно-психиатрический эксперт</li>
        <li>Специалист в кризисных и реабилитационных центрах</li>
        <li>Научный сотрудник или преподаватель в медицинских вузах</li>
        <li>Консультант по психическому здоровью в международных организациях</li>
      </ul>
      <h2>Востребованность и доход</h2>
      <p>Психиатры входят в число наиболее востребованных врачей в Европе.</p>
      <p>
        <strong>Средний доход составляет от €60,000 до €100,000 в год,</strong> с возможностью профессионального роста и работы за рубежом.
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом магистра, признанный во многих странах</li>
        <li>Обучение на русском или английском языке</li>
        <li>Гибкие форматы — очно или дистанционно</li>
        <li>Клиническая практика в современных психиатрических центрах</li>
        <li>Индивидуальное сопровождение студента и помощь в карьере</li>
        <li>Поддержка научной и практической деятельности</li>
      </ul>
      <h2>Обучение, которое делает мир устойчивее</h2>
      <p>
        Наши выпускники — это профессионалы, которые умеют слушать, понимать и помогать. Они работают там, где человеческая поддержка
        особенно важна.
      </p>
      <br />
      <p className="padding-left">«Психиатрия — это искусство медицины и наука человечности.»</p>
      <h2>Как поступить?</h2>
      <p>Оставьте заявку, чтобы получить подробную информацию о сроках, стоимости и процессе поступления.</p>
    </>
  ),
  contentSearch: `
    Диплом: магистра
    Форма обучения: очная или дистанционная
    Форма связи: Получить консультацию приемной комиссии

    Психиатрия — помощь там, где она особенно необходима
    Психиатрия — это одна из самых значимых и сложных областей медицины, направленная на диагностику, лечение и профилактику психических расстройств. Психическое здоровье — неотъемлемая часть общего благополучия человека, и современные психиатры играют ключевую роль в поддержании этого баланса.
    Программа сочетает фундаментальную медицинскую подготовку с глубоким изучением клинической психиатрии, психофармакологии и психотерапии.

    Что вы будете изучать?
    • Общая и клиническая психиатрия
    • Психофармакология и методы медикаментозного лечения
    • Психотерапевтические подходы (когнитивно-поведенческая, психодинамическая и др.)
    • Судебная психиатрия
    • Психиатрия в экстренных состояниях
    • Психосоматические расстройства
    • Этические и правовые аспекты психиатрии
    • Психиатрическая помощь детям и подросткам
    Программа включает практику в клиниках, специализированных отделениях и участие в междисциплинарных консилиумах.

    Кем можно работать после окончания?
    • Врач-психиатр в государственных и частных учреждениях
    • Психотерапевт (при наличии дополнительной подготовки и лицензии)
    • Судебно-психиатрический эксперт
    • Специалист в кризисных и реабилитационных центрах
    • Научный сотрудник или преподаватель в медицинских вузах
    • Консультант по психическому здоровью в международных организациях

    Востребованность и доход
    Психиатры входят в число наиболее востребованных врачей в Европе.
    Средний доход составляет от €60,000 до €100,000 в год, с возможностью профессионального роста и работы за рубежом.

    Почему выбирают нас?
    • Европейский диплом магистра, признанный во многих странах
    • Обучение на русском или английском языке
    • Гибкие форматы — очно или дистанционно
    • Клиническая практика в современных психиатрических центрах
    • Индивидуальное сопровождение студента и помощь в карьере
    • Поддержка научной и практической деятельности

    Обучение, которое делает мир устойчивее
    Наши выпускники — это профессионалы, которые умеют слушать, понимать и помогать. Они работают там, где человеческая поддержка особенно важна.
    «Психиатрия — это искусство медицины и наука человечности.»

    Как поступить?
    Оставьте заявку, чтобы получить подробную информацию о сроках, стоимости и процессе поступления.
  `,
};
